// extracted by mini-css-extract-plugin
export var alertIcon = "_td-0";